import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent  implements OnInit {
  title = 'gradientai-platform';

  style = {
    height: '600px'
  }
  ngOnInit() {
    this.style.height = (window.innerHeight - 80) + 'px'
  }
}
